import { render, staticRenderFns } from "./DetallesApelacion.vue?vue&type=template&id=3a54c524&"
import script from "./DetallesApelacion.vue?vue&type=script&lang=js&"
export * from "./DetallesApelacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports